define('lib/backbone/Backbone.Mixins.Transport.API',['require','lib/prototype/String.prototype','whatwg-fetch','underscore','translate','backbone','lib/Podio.Config','lib/Podio.Event'],function (require) {

  require('lib/prototype/String.prototype');
  require('whatwg-fetch');
  var _ = require('underscore');
  var t = require('translate');
  var Backbone = require('backbone');
  var podioConfig = require('lib/Podio.Config');
  var podioEvent = require('lib/Podio.Event');


  var helpers = {
    _triggerTransportGlobalErrorEvent: function(error_description, options) {
      podioEvent.trigger(podioEvent.Types.onTransportGlobalError, error_description, options);
    },

    formatErrorResponse: function(xhr) {
      return xhr.responseText && JSON.parse(xhr.responseText);
    },

    triggerSomethingWentWrong: function(requestOptions) {
      requestOptions = requestOptions || {};

      helpers._triggerTransportGlobalErrorEvent(t('Sorry, something went wrong. Please try again. #error'), { sticky: false, dismissGenericErrorMessage: requestOptions.dismissGenericErrorMessage });
    },

    insertUrlParam: function (url, key, value) {
      var kvp, i, x;

      key = encodeURI(key);
      value = encodeURI(value);

      if (url.indexOf('?') === -1) {
        return url + '?{0}={1}'.format(key, value);
      }

      kvp = url .split('&');
      i = kvp.length;

      while (i--) {
        x = kvp[i].split('=');

        if (x[0] === key) {
          x[1] = value;
          kvp[i] = x.join('=');
          break;
        }
      }

      if (i < 0) {
        kvp[kvp.length] = [key,value].join('=');
      }

      return kvp.join('&');
    }
  };

  function _onAjaxError(requestOptions, xhr, statusText, error) {
    var jsonBody = helpers.formatErrorResponse(xhr);

    if (requestOptions && requestOptions.ignoreHTTPErrors) {
      return;
    }

    if (jsonBody && jsonBody.error_propagate && !_.isEmpty(jsonBody.error_description)) {
      helpers._triggerTransportGlobalErrorEvent(jsonBody.error_description, { sticky: true, dismissGenericErrorMessage: requestOptions.dismissGenericErrorMessage });
    } else if (xhr.statusText !== 'abort' && xhr.getAllResponseHeaders()) {
      //Abort is aborted using .abort(), response headers are empty on navigation
      helpers.triggerSomethingWentWrong(requestOptions);
    }
  }

  function _addPodioOptions(options) {
    // insert the auth token just before the request is made
    // because we might not have the url yet when sync is called
    options = options || {};
    options.beforeSend = function(xhr, request) {
      request.url = helpers.insertUrlParam(request.url, 'authenticity_token', podioConfig.authenticity_token());
    };
    options.xhrFields = { withCredentials: true };
    // to be able to identify this request we reuse the request id from the server side request and add a sub-request-id
    options.headers = { "X-Podio-Request-Id": podioConfig.podioRequestId + '_' + Math.random().toString(36).substr(2, 4) };

    // disable the global success and error handlers defined in Podio.Transport
    options.global = false;

    // extend the error callback
    options.error = _.wrap(options.error, function(originalError) {
      var args = _.rest(_.toArray(arguments));
      args.unshift(options);

      _onAjaxError.apply(this, args);

      if (_.isFunction(originalError)) {
        originalError.apply(this, args);
      }
    });
  }

  return {
    request: function(method, url, data, options) {
      method = method.toLowerCase();
      options = options || {};
      _.extend(options, {
        contentType: 'application/json',
        dataType: 'json',
        type: method,
        url: podioConfig.endpoints.apiProxy + url
      });

      if (method === 'get') {
        options.data = data;
      } else {
        options.processData = false;
        options.data = JSON.stringify(data);
      }

      _addPodioOptions(options);

      return Backbone.ajax(options);
    },

    fetch: function(method, url, data, options) {
      var requestOptions = _.extend(options || {}, {
        headers: new window.Headers({
          'Content-Type': 'application/json',
          'X-Podio-Request-Id': podioConfig.podioRequestId + '_' + Math.random().toString(36).substr(2, 4),
          'X-CSRF-Token': podioConfig.authenticity_token(),
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json, text/javascript, */*; q=0.01'
        }),
        credentials: 'include',
        method: method,
        body: JSON.stringify(data)
      });

      var urlFormatted = helpers.insertUrlParam(podioConfig.endpoints.apiProxy + url, 'authenticity_token',
        podioConfig.authenticity_token());

      return window.fetch(urlFormatted, requestOptions).then(function(response) {
        if (!response.ok) {
          throw new Error(response.statusText)
        }

        if (response.headers.get('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1) {
          return response.json();
        }
      });
    },

    sync: function(method, model, options) {
      var promise;

      _addPodioOptions(options);

      // we don't support PATCH in our API
      if (method === 'patch') {
        method = 'update';
      }

      if (this instanceof Backbone.Collection) {
        promise = Backbone.Collection.prototype.sync.apply(this, [method, model, options]);
      } else {
        promise = Backbone.Model.prototype.sync.apply(this, [method, model, options]);
      }

      this.lastPromise = promise;

      return promise;
    },

    formatErrorResponse: helpers.formatErrorResponse,
    triggerSomethingWentWrong: helpers.triggerSomethingWentWrong,

    /* expose for testing */
    __private: {
      _onAjaxError: _onAjaxError,
      helpers: helpers
    }
  };

});

